import Alpine from 'alpinejs';
import {scrollStagger} from '@groupthought/analog-ui/alpine';

Alpine.plugin(scrollStagger);
